/**
 * Algolia routing for Vue/Inertia (Marketplace.vue, SSR).
 * Re-exports shared logic with Vue-reactive state wrappers + Inertia navigation hooks.
 */
export * from "./algoliaRouting.shared";

import { ref, watch } from "vue";

import {
    curatedSearchConfig as curatedSearchConfigStore,
    rangeFiltersState as rangeFiltersStateStore,
    subscribeCuratedSearchConfig,
    subscribeRangeFiltersState,
    type CuratedSearchConfig,
    type RangeFiltersState,
} from "./algoliaRouting.shared";

import "./algoliaRouting.inertia";

/** Vue-reactive mirror of the plain shared store (for Marketplace.vue widgets). */
export const rangeFiltersState = ref<RangeFiltersState>({
    ...rangeFiltersStateStore.value,
});

subscribeRangeFiltersState(() => {
    rangeFiltersState.value = rangeFiltersStateStore.value;
});

watch(
    rangeFiltersState,
    (next) => {
        rangeFiltersStateStore.value = next;
    },
    { deep: true },
);

/** Vue-reactive mirror of the plain shared curated-search config. */
export const curatedSearchConfig = ref<CuratedSearchConfig>({
    ...curatedSearchConfigStore.value,
});

subscribeCuratedSearchConfig(() => {
    curatedSearchConfig.value = curatedSearchConfigStore.value;
});

watch(
    curatedSearchConfig,
    (next) => {
        curatedSearchConfigStore.value = next;
    },
    { deep: true },
);
